import { createRouter, createWebHistory } from "vue-router";

import Step1CustomerInfo from "../views/Step1CustomerInfo.vue";
import Step2Request from "../views/Step2Request.vue";
import Step3Confirm from "../views/Step3Confirm.vue";
import Step4Complete from "../views/Step4Complete.vue";

const routes = [
  { path: "/", redirect: "/step1" },
  {
    path: "/step1",
    component: Step1CustomerInfo,
    name: "step1",
  },
  {
    path: "/step2",
    component: Step2Request,
    name: "step2",
    meta: { requiresStepCompletion: "step1" },
  },
  {
    path: "/step3",
    component: Step3Confirm,
    name: "step3",
    meta: { requiresStepCompletion: "step2" },
  },
  {
    path: "/step4",
    component: Step4Complete,
    name: "step4",
    meta: { requiresStepCompletion: "step3" },
  },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(_to, _from, savedPosition) {
    if (savedPosition) {
      return savedPosition; // 戻る時は元の位置
    }
    return { top: 0 }; // それ以外は常に一番上
  },
});

// ナビゲーションガード：ステップの完了状態をチェック
router.beforeEach((to, _from, next) => {
  // step2以降へのアクセス時、前のステップが完了しているかチェック
  if (to.meta.requiresStepCompletion) {
    const requiredStep = to.meta.requiresStepCompletion as string;
    const isCompleted =
      sessionStorage.getItem(`${requiredStep}Completed`) === "true";

    if (!isCompleted) {
      // 前のステップが完了していない場合、step1へリダイレクト
      next("/step1");
      return;
    }
  }

  next();
});

// ステップ完了をマーク（各ステップコンポーネントから呼び出される）
export function markStepCompleted(step: string) {
  sessionStorage.setItem(`${step}Completed`, "true");
}

// フォーム送信完了後、全てのステップフラグをクリア
export function clearStepFlags() {
  sessionStorage.removeItem("step1Completed");
  sessionStorage.removeItem("step2Completed");
  sessionStorage.removeItem("step3Completed");
}

export default router;
